import { render, staticRenderFns } from "./AllLoanRepayments.vue?vue&type=template&id=67a57d8a&scoped=true"
import script from "./AllLoanRepayments.vue?vue&type=script&lang=js"
export * from "./AllLoanRepayments.vue?vue&type=script&lang=js"
import style0 from "./AllLoanRepayments.vue?vue&type=style&index=0&id=67a57d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a57d8a",
  null
  
)

export default component.exports